import { installLicense } from "../../api/endpoints/account";
import { createMutation } from "./apiHooks";

export const useInstallLicense = createMutation(installLicense, {
  mutationKey: ["License", "Install"],
});
